import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('hg-chip')
export class HgChip extends LitElement {
  static styles = css`
    :host {
      display: inline-flex;
    }
    .chip {
      display: inline-flex;
      align-items: center;
      gap: 0.35rem;
      font-size: 10.5px;
      font-weight: 700;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: var(--hg-forest);
      background: transparent;
      border: 0;
      padding: 0;
    }
    :host([tone='coral']) .chip {
      color: var(--hg-coral);
    }
    :host([tone='neutral']) .chip {
      color: var(--hg-muted);
    }
    :host([tone='soft']) .chip {
      color: var(--hg-forest);
    }
    :host([selected]) .chip {
      color: var(--hg-ink);
    }
  `;

  @property({ reflect: true }) tone: 'outline' | 'soft' | 'coral' | 'neutral' = 'outline';
  @property({ type: Boolean, reflect: true }) selected = false;

  render() {
    return html`<span class="chip"><slot></slot></span>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'hg-chip': HgChip;
  }
}
